import { useEffect, useState } from "react";
import Main from "./Main";
import { CONFIGS, LABELS } from "./constants";
import { PriorPayoutShopIdsRequest } from "../../features/api-interfaces";
import { usePostPriorPayoutShopIdsMutation } from "../../features/api";
import { getMessageItemList } from "../UI/table/ErrorTable";

/**
 * ShopID登録表示
 * ID払い出し結果受領・取込の表示に必要な以下の内容を設定する。
 *  事前払出ID名
 *  登録API呼び出し処理
 *  入力IDリスト
 *  入力IDリスト設定処理
 *  スピナー表示フラグ
 *
 * @param props.setErrorMessageList エラーメッセージ設定処理
 * @returns
 */
const PriorPayoutShopIds = (props: any) => {
  // 入力IDリスト
  const [idList, setIdList] = useState("");

  // ShopID登録API
  const [priorPayoutShopIds] = usePostPriorPayoutShopIdsMutation();

  // スピナー表示処理用
  const [spinnerDisplayFlag, isSpinnerDisplayFlag] = useState(false);

  // 初回のみエラーメッセージリストの初期化を行う
  useEffect(() => {
    props.setErrorMessageList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 登録API呼び出し処理
  const callRegisterApi = () => {
    // 入力IDリストを改行で分割後、空文字を除外してrequestに設定
    const inputList = idList.split(CONFIGS.LF_CODE).filter((s) => {
      return s !== "";
    });

    const request = inputList.map((value) => {
      const shopIds = value.split(/[\s,]/g);
      return {
        shopID: shopIds[0],
        spid: shopIds[1],
      } as PriorPayoutShopIdsRequest;
    });

    // スピナー表示
    isSpinnerDisplayFlag(true);

    // API呼び出し
    priorPayoutShopIds(request)
      .unwrap()
      .then((res) => {
        // スピナー非表示
        isSpinnerDisplayFlag(false);

        if ("error" === res.status) {
          if (
            res.detailMessageList !== null &&
            res.detailMessageList.length !== 0
          ) {
            props.setErrorMessageList(
              getMessageItemList(res.detailMessageList)
            );
          }
        } else {
          // 正常終了時にはIdListとエラーメッセージリストを空にする。
          setIdList("");
          props.setErrorMessageList([]);
        }
      });
  };

  return (
    <Main
      priorPayoutIdName={LABELS.SHOP_IDS}
      callRegisterApi={callRegisterApi}
      idList={idList}
      setIdList={setIdList}
      spinnerDisplayFlag={spinnerDisplayFlag}
      placeholder={LABELS.SHOP_ID_TEXT_AREA_PLACE_HOLDER}
    />
  );
};

export default PriorPayoutShopIds;
